<template>
  <v-card class="languages mt-3 elevation-4">
    <v-toolbar card prominent class="transparent">
      <v-toolbar-title class="title">Languages</v-toolbar-title>
      <v-spacer />
      <can I="edit" a="Profile">
        <v-tooltip left v-if="!editing">
          <v-btn
            color="secondary"
            small fab slot="activator"
            @click="editing = true"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <span>Add a language</span>
        </v-tooltip>
      </can>
    </v-toolbar>

    <v-divider />

    <v-card-text class="pa-0">
      <table class="v-table theme--dark">
        <tbody>
          <tr v-for="language in profile.languages" :key="`language-${language.id}`">
            <th class="text-xs-right">{{ language.language }}</th>
            <td>{{ language.description }}</td>
            <td class="text-xs-right">
              <can I="edit" a="Profile">
                <v-tooltip left color="grey darken-3">
                  <v-btn small flat fab
                    color="error"
                    @click="remove(language.id)"
                    slot="activator"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <span>Remove</span>
                </v-tooltip>
              </can>
            </td>
          </tr>
        </tbody>
      </table>
    </v-card-text>
    <can I="edit" a="Profile">
      <v-form v-if="editing">
        <v-card-text>
          <v-text-field
            label="Language"
            v-model="language.language"
          />
          <v-select
            label="Proficiency"
            v-model="language.proficiency"
            :items="proficiencies"
          />
        </v-card-text>
        <v-card-actions><v-spacer />
          <v-btn flat @click="editing = false" color="grey">Cancel</v-btn>
          <v-btn color="primary" @click="add">Add</v-btn>
        </v-card-actions>
      </v-form>
    </can>
  </v-card>
</template>

<script>
// Helpers
import { mapGetters } from 'vuex'

// Data
import proficiencies from '@/data/language_proficiencies'

// Vue Components
export default {
  data() {
    return {
      editing: false,
      proficiencies,
      language: {
        profile: { id: this.$route.params.id },
        language: '',
        proficiency: 0,
      },
    }
  },
  computed: mapGetters({ profile: 'admin/profiles/find' }),
  methods: {
    add() {
      this.$store.dispatch('admin/languageProficiencies/create', this.language).then(
        // Success
        () => {
          this.$store.commit('snackbar', {
            text: 'Language was added successfully',
            type: 'success',
          })
          this.$store.dispatch('admin/profiles/fetch', this.profile.id)
          this.editing = false
          this.language.language = ''
          this.language.proficiency = 0
        },
        // Failure
        () => {
          this.$store.commit('snackbar', {
            text: 'Language could not be added',
            type: 'error',
          })
        }
      )
    },
    remove(id) {
      this.$store.dispatch('admin/languageProficiencies/destroy', id).then(
        // Success
        () => {
          this.$store.commit('snackbar', {
            text: 'Language was removed successfully',
            type: 'success',
          })
          this.$store.dispatch('admin/profiles/fetch', this.profile.id)
        },
        // Failure
        () => {
          this.$store.commit('snackbar', {
            text: 'Language could not be removed',
            type: 'error',
          })
        }
      )
    },
  },
}
</script>
